import { Link, Typography } from '@/shared/ui';

import { SUPPORT_EMAIL } from '@/config/constants';
import { spacing } from '@/config/ui';
import { BaseLayout, CenteredLayout } from '@/shared/ui/layout';
import Button from '@/shared/ui/primitives/Button';
import GoLogo from '@/shared/ui/primitives/GoLogo';

export const MaintenanceMode = () => {
  return (
    <BaseLayout>
      <CenteredLayout className='text-center'>
        <GoLogo size={74} />
        <Typography
          sx={{
            mb: spacing[2],
            mt: spacing[4]
          }}
          variant='h1'
        >
          We'll be back soon
        </Typography>
        <Typography
          sx={{ mb: spacing[1], fontWeight: 500 }}
          variant='subtitle1'
        >
          GX Go is down for maintenance. <br />
          You’ll be redirected when it’s back online.
        </Typography>

        <Typography sx={{ mb: spacing[2] }}>
          Need assistance? Drop us a line at{' '}
          <Link
            className='cursor-pointer text-white underline'
            href={`mailto:${SUPPORT_EMAIL}`}
          >
            {SUPPORT_EMAIL}
          </Link>
        </Typography>
        <Button
          component='a'
          href='https://www.general-index.com'
          size='large'
          sx={{
            width: 250
          }}
          target='_blank'
          variant='contained'
        >
          Visit our Website
        </Button>
      </CenteredLayout>
    </BaseLayout>
  );
};
